export const PENDING_EMAIL_VERIFIED_EVENT_KEY = 'gtm_pending_user_email_verified_event_id';
export const EMAIL_VERIFIED_EVENT_TRACKED_KEY = 'gtm_user_email_verified_tracked_event_id';
